import Button from 'components/Button/Button';
import CountryLogo from 'components/CountryLogo/CountryLogo';
import LanguageToggle from 'components/LanguageToggle/LanguageToggle';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, {
  WithLanguageProps
} from 'enhancers/withLanguageState';
import withWindowState, { WithWindowState } from 'enhancers/withWindowState';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';

import NavBar from '../NavBar/NavBar';
import MobileHeader from './MobileHeader';
import withDrawerState, { WithDrawerProps } from 'enhancers/withDrawerState';

interface IProps {
  showGlobalRegistration: boolean;
  registerLink: string | null;
  buttonText: string | null;
}

type Props = WithWindowState &
  RouteComponentProps<any> &
  WithColorQueryProps &
  IWithCountryProps &
  WithLanguageProps &
  IProps &
  WithDrawerProps;

export const Header: React.SFC<Props> = props => {
  const backgroundImage =
    !props.loading &&
    props.data &&
    props.data.fetch.Common &&
    props.data.fetch.Common.Header &&
    props.data.fetch.Common.Header.BackgroundImage
      ? props.data.fetch.Common.Header.BackgroundImage.src
      : '';
  const backgroundColor =
    !props.loading &&
    props.data &&
    props.data.fetch.Common &&
    props.data.fetch.Common.Header &&
    props.data.fetch.Common.Header.BackgroundColor
      ? props.data.fetch.Common.Header.BackgroundColor
      : '#ffffff';
  const color = getTextColor(backgroundColor);

  const closeNavbar = () => {
    props.toggleDrawer(false);
  };

  const rightSection = (
    <RightSection>
      <LanguageToggle />
      <span onClick={closeNavbar}>
        {props.showGlobalRegistration && (
          <RegisterButton link={'/register'}>
            {props.getText(props.buttonText)}
          </RegisterButton>
        )}
        {!props.loading &&
          props.data &&
          props.data.fetch.Country.Scores &&
          props.data.fetch.Country.Scores.Active === 'yes' && (
            <NavButton link={`/scores`}>
              {props.getText(
                !props.loading && props.data && props.data.fetch.Country.Navbar
                  ? props.data.fetch.Country.Navbar.Scores
                  : 'Scores'
              )}
            </NavButton>
          )}
      </span>
    </RightSection>
  );

  if (props.window.width < 750) {
    return (
      <StyledMobileHeader color={color} background={backgroundColor}>
        {rightSection}
      </StyledMobileHeader>
    );
  }
  return (
    <Container
      style={{
        background: backgroundImage
          ? `url(${backgroundImage})`
          : backgroundColor,
        color
      }}
    >
      <LogoContainer>
        <CountryLogo color={color} />
      </LogoContainer>
      <NavBar color={color} />
      {/* <StyledCountrySelect withFlag={true} /> */}
      {rightSection}
    </Container>
  );
};

const NavButton = styled(Button)`
  font-size: 11px;
  padding: 5px 14px;
`;

const RegisterButton = styled(NavButton)`
  background-color: #81d8c3;
  color: black;
  margin-bottom: 10px;
`;

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-top: -5px;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  padding: 0 80px;
  justify-content: space-between;
  height: 104px;
  /*height: 170px */
  @media (max-width: 1300px) {
    & > * {
      flex: 1;
    }
    & > *:last-child,
    & > *:first-child {
      flex: 0;
    }
  }
  @media (max-width: 1000px) {
    padding: 20px;
    height: 110px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface IMobileHeaderStyleProps {
  background: string;
}

const StyledMobileHeader = styled(MobileHeader)<IMobileHeaderStyleProps>`
  background: ${p => p.background};
`;

export default withDrawerState(
  withLanguageState(
    withRouter(withCountry(withColorQuery(withWindowState(Header))))
  )
);



// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx